module.exports = __webpack_public_path__ + "img/login-bg.69a55810.png";